import AllAssetsActionTypes from './allAssets-types'

export const startFetchAllAssets = data => ({
    type: AllAssetsActionTypes.START_FETCH_ALL_ASSETS,
    payload: data,
})

export const successFetchAllAssets = data => ({
    type: AllAssetsActionTypes.SUCCESS_FETCH_ALL_ASSETS,
    payload: data,
})

export const failureFetchAllAssets = data => ({
    type: AllAssetsActionTypes.FAILURE_FETCH_ALL_ASSETS,
    payload: data,
})

/*******************  Quick Deposit Asset ********************* */
export const startGetQuickDepositAsset = data => ({
    type: AllAssetsActionTypes.START_GET_QUICK_DEPOSIT_ASSET,
    payload: data,
})
export const successGetQuickDepositAsset = data => ({
    type: AllAssetsActionTypes.SUCCESS_GET_QUICK_DEPOSIT_ASSET,
    payload: data,
})
export const finishGetQuickDepositAsset = data => ({
    type: AllAssetsActionTypes.FINISH_GET_QUICK_DEPOSIT_ASSET,
    payload: data,
})
export const failureGetQuickDepositAsset = data => ({
    type: AllAssetsActionTypes.FAILURE_GET_QUICK_DEPOSIT_ASSET,
    payload: data,
})
